var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    fillRule: "evenodd",
    d: "M6 13.33A7.33 7.33 0 0113.33 6H48a7.33 7.33 0 017.33 7.33V27.5a2 2 0 11-4 0v-4.17H10V48c0 1.84 1.5 3.33 3.33 3.33H24.5a2 2 0 010 4H13.33A7.33 7.33 0 016 48V13.33zm4 6h41.33v-6C51.33 11.5 49.84 10 48 10H13.33A3.33 3.33 0 0010 13.33v6zm6.13-6.6a2 2 0 00-2.02.5 2.01 2.01 0 102.02-.5zm6.18-.09a2 2 0 011.43.59 2.01 2.01 0 11-1.43-.59zm7.37.09a2 2 0 00-2.02.5 2.01 2.01 0 102.02-.5z",
    clipRule: "evenodd",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M42.5 44v9m7.5 0v-9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 48,
    r: 14,
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}

export default SvgPause;